import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxFontSmSecondaryProps extends ITextBoxProps {}

export const TextBoxFontSmSecondary = ({
  title,
  color = Colors.TEXT_ICON_SECONDARY,
  font = TextBoxTypes.FontSm,
  ...rest
}: ITextBoxFontSmSecondaryProps): JSX.Element => (
  <TextBox title={title} color={color} font={font} {...rest} />
)
